var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.companyItemTypes
    ? _c("div", [
        _c(
          "table",
          { staticClass: "table is-bordered is-narrow is-fullwidth" },
          [
            _c("thead", [
              _c(
                "tr",
                {
                  staticClass: "no-border",
                  class: `summary-background-text-${_vm.$theme.name}`,
                },
                [
                  _c("th", { staticClass: "is-title" }, [_vm._v("Category")]),
                  _vm._l(_vm.allAssessments, function (assessment) {
                    return _c(
                      "th",
                      {
                        key: assessment.assessmentID,
                        staticClass: "has-text-right is-subtotal",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              assessment.subQuoteNo === 0
                                ? "Main"
                                : `Supp-${assessment.subQuoteNo}`
                            ) +
                            " "
                        ),
                      ]
                    )
                  }),
                  _vm.allAssessments.length > 1
                    ? _c("th", { staticClass: "has-text-right is-subtotal" }, [
                        _vm._v(" Summary "),
                      ])
                    : _vm._e(),
                  _vm.allAssessments.length === 0
                    ? _c("th", { staticClass: "has-text-right" }, [
                        _vm._v("Main"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c("tfoot", { staticClass: "no-border" }, [
              _c(
                "tr",
                {
                  staticClass: "has-border-bottom-4",
                  class: [`summary-background-text-${_vm.$theme.name}`],
                },
                [
                  _vm._m(0),
                  _vm._l(_vm.allAssessments, function (assessment) {
                    return _c(
                      "td",
                      {
                        key: assessment.assessmentID,
                        staticClass: "has-text-right",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.getAssessmentTotal(assessment),
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  }),
                  _vm.allAssessments.length > 1
                    ? _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.getGrandAssessmentTotal(),
                              _vm.$userInfo.locale
                            )
                          ) + " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.allAssessments.length === 0
                    ? _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(0, _vm.$userInfo.locale)
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm.value.discount
                ? _c(
                    "tr",
                    [
                      _c("td", [_vm._v("Discount")]),
                      _vm.allAssessments.length > 1
                        ? [
                            _c(
                              "td",
                              { staticClass: "has-text-right has-text-danger" },
                              [
                                _vm._v(
                                  "- " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.value.discount,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.allAssessments.slice(
                                0,
                                _vm.allAssessments.length - 1
                              ),
                              function (assessment) {
                                return _c(
                                  "td",
                                  {
                                    key: assessment.assessmentID,
                                    staticClass: "has-text-right",
                                  },
                                  [_vm._v("- ")]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "td",
                        { staticClass: "has-text-right has-text-danger" },
                        [
                          _vm._v(
                            "- " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.value.discount,
                                  _vm.$userInfo.locale
                                )
                              )
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.value.excess && _vm.value.excessWithGst
                ? _c(
                    "tr",
                    [
                      _c("td", [_vm._v("Excess")]),
                      _vm.allAssessments.length > 1
                        ? [
                            _c(
                              "td",
                              { staticClass: "has-text-right has-text-danger" },
                              [
                                _vm._v(
                                  "- " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.value.excess,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.allAssessments.slice(
                                0,
                                _vm.allAssessments.length - 1
                              ),
                              function (assessment) {
                                return _c(
                                  "td",
                                  {
                                    key: assessment.assessmentID,
                                    staticClass: "has-text-right",
                                  },
                                  [_vm._v("- ")]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "td",
                        { staticClass: "has-text-right has-text-danger" },
                        [
                          _vm._v(
                            "- " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.value.excess,
                                  _vm.$userInfo.locale
                                )
                              )
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "tr",
                {
                  staticClass: "has-border-bottom-4",
                  class: [`summary-background-primary-${_vm.$theme.name}`],
                },
                [
                  _c("td", [
                    _vm._v("GST "),
                    _c("span", { staticClass: "subtext" }, [
                      _vm._v("(" + _vm._s(_vm.value.gstRate) + "%)"),
                    ]),
                  ]),
                  _vm.allAssessments.length > 1
                    ? [
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm.mainQuoteTotalGst > 0
                            ? _c("span", [_vm._v("+")])
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.mainQuoteTotalGst,
                                  _vm.$userInfo.locale
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _vm._l(
                          _vm.allAssessments.slice(
                            1,
                            _vm.allAssessments.length
                          ),
                          function (assessment) {
                            return _c(
                              "td",
                              {
                                key: assessment.assessmentID,
                                staticClass: "has-text-right",
                              },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.getAssessmentTotal(assessment) *
                                          (_vm.value.gstRate / 100),
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }
                        ),
                      ]
                    : _vm._e(),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm.invTotalExGst > 0
                      ? _c("span", [_vm._v("+")])
                      : _vm._e(),
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.invTotalExGst * (_vm.value.gstRate / 100),
                          _vm.$userInfo.locale
                        )
                      ) + " "
                    ),
                  ]),
                ],
                2
              ),
              _vm.showInvAmtIncGst
                ? _c(
                    "tr",
                    { class: `summary-background-text-${_vm.$theme.name}` },
                    [
                      _vm._m(1),
                      _vm.allAssessments.length > 1
                        ? [
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.mainQuoteTotalIncGst,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _vm._l(
                              _vm.allAssessments.slice(
                                1,
                                _vm.allAssessments.length
                              ),
                              function (assessment) {
                                return _c(
                                  "td",
                                  {
                                    key: assessment.assessmentID,
                                    staticClass: "has-text-right",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          _vm.getAssessmentTotal(assessment) *
                                            (_vm.value.gstRate / 100 + 1),
                                          _vm.$userInfo.locale
                                        )
                                      ) + " "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.invTotalExGst * (_vm.value.gstRate / 100 + 1),
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.value.ownersContribution
                ? _c(
                    "tr",
                    [
                      _vm._m(2),
                      _vm.allAssessments.length > 1
                        ? [
                            _c(
                              "td",
                              { staticClass: "has-text-right has-text-danger" },
                              [
                                _vm._v(
                                  "- " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.value.ownersContribution *
                                          (_vm.value.gstRate / 100 + 1),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.allAssessments.slice(
                                0,
                                _vm.allAssessments.length - 1
                              ),
                              function (assessment) {
                                return _c(
                                  "td",
                                  {
                                    key: assessment.assessmentID,
                                    staticClass: "has-text-right",
                                  },
                                  [_vm._v("- ")]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "td",
                        { staticClass: "has-text-right has-text-danger" },
                        [
                          _vm._v(
                            "- " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.value.ownersContribution *
                                    (_vm.value.gstRate / 100 + 1),
                                  _vm.$userInfo.locale
                                )
                              )
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.value.excess && !_vm.value.excessWithGst
                ? _c(
                    "tr",
                    [
                      _c("td", [_vm._v("Excess")]),
                      _vm.allAssessments.length > 1
                        ? [
                            _c(
                              "td",
                              { staticClass: "has-text-right has-text-danger" },
                              [
                                _vm._v(
                                  "- " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.value.excess,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.allAssessments.slice(
                                0,
                                _vm.allAssessments.length - 1
                              ),
                              function (assessment) {
                                return _c(
                                  "td",
                                  {
                                    key: assessment.assessmentID,
                                    staticClass: "has-text-right",
                                  },
                                  [_vm._v("- ")]
                                )
                              }
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "td",
                        { staticClass: "has-text-right has-text-danger" },
                        [
                          _vm._v(
                            "- " +
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.value.excess,
                                  _vm.$userInfo.locale
                                )
                              )
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "tr",
                { class: `summary-background-success-${_vm.$theme.name}` },
                [
                  _vm._m(3),
                  _vm.allAssessments.length > 1
                    ? [
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.mainQuoteTotalPayable,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _vm._l(
                          _vm.allAssessments.slice(
                            1,
                            _vm.allAssessments.length
                          ),
                          function (assessment) {
                            return _c(
                              "th",
                              {
                                key: assessment.assessmentID,
                                staticClass: "has-text-right",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.getAssessmentTotal(assessment) *
                                        (_vm.value.gstRate / 100 + 1),
                                      _vm.$userInfo.locale
                                    )
                                  ) + " "
                                ),
                              ]
                            )
                          }
                        ),
                      ]
                    : _vm._e(),
                  _c("th", { staticClass: "has-text-right" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalPayableIncGst,
                            _vm.$userInfo.locale
                          )
                        ) +
                        " "
                    ),
                  ]),
                ],
                2
              ),
            ]),
            _c(
              "tbody",
              { staticClass: "has-bottom-border-only no-border-last-row" },
              _vm._l(_vm.companyItemTypes, function (itemType) {
                return _c(
                  "tr",
                  { key: itemType.itemCategoryId },
                  [
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getDisplayName(itemType.itemCategoryType)
                          ) +
                          " "
                      ),
                    ]),
                    _vm._l(_vm.allAssessments, function (assessment) {
                      return _c(
                        "td",
                        {
                          key: assessment.assessmentID,
                          staticClass: "has-text-right",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.getAssessmentTotal(
                                    assessment,
                                    itemType.itemCategoryType
                                  ),
                                  _vm.$userInfo.locale
                                )
                              )
                          ),
                        ]
                      )
                    }),
                    _vm.allAssessments.length > 1
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.getGrandAssessmentTotal(
                                    itemType.itemCategoryType
                                  ),
                                  _vm.$userInfo.locale
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.allAssessments.length === 0
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(0, _vm.$userInfo.locale)
                            )
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("Owner Cont. "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", [
      _vm._v("Total Payable "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }